import { render, staticRenderFns } from "./ButtonCopyValue.vue?vue&type=template&id=05a9a00b"
import script from "./ButtonCopyValue.vue?vue&type=script&lang=js"
export * from "./ButtonCopyValue.vue?vue&type=script&lang=js"
import style0 from "./ButtonCopyValue.vue?vue&type=style&index=0&id=05a9a00b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports